// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media (max-width: 800px) {\n.mobile-switch {\n    min-height: 3rem;\n    padding-right: 1rem;\n}\n.flex-row.flex-basis-50 {\n    flex-basis: 100%;\n}\n}\n@media (max-width: 500px) {\n.flex-basis-40.align-center {\n    flex-basis: 55%;\n    margin: 1rem 0;\n}\n.country-desc {\n    text-align: center;\n}\n.flex-row {\n    justify-content: center;\n}\n}\n", ""]);
// Exports
module.exports = exports;
